import usePayWall from "@/hooks/usePaywall";
import useSubscriptionPermission from "@/hooks/useSubscriptionPermission";
import { Tab } from "@headlessui/react";
import { useRect } from "@reach/rect";
import clsx from "clsx";
import { useRef, useState } from "react";
import { useWindowScroll } from "react-use";
import Nutrition from "./Nutrition";

const RecipeTabs = ({ recipe, ingredients, method, cta = null }) => {
  const { subscriptionPermission } = useSubscriptionPermission(recipe);
  const { y } = useWindowScroll();
  const { setPaywall } = usePayWall();

  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const tabScrollY = useRef({
    0: 0,
    1: 0,
  });

  const ref = useRef(null);
  const rect = useRect(ref);

  // State to manage the sum of header and search bar
  const topOffset = 120;

  /*
  useEffect(() => {
    const rootStyle = getComputedStyle(document.documentElement);
    const headerHeight = parseInt(
      rootStyle.getPropertyValue("--header-height"),
      10
    );
    const notificationHeight = parseInt(
      rootStyle.getPropertyValue("--notification-height"),
      10
    );
    setTopOffset(headerHeight + notificationHeight);
  }, []);
	*/

  const sticky = rect?.top <= topOffset && rect?.bottom > topOffset;

  return (
    <div ref={ref} className={clsx("RecipeTabs")}>
      <Tab.Group
        onChange={(index) => {
          if (index === 2 && !subscriptionPermission.canUseNutritionalInfo) {
            setPaywall({
              isOpen: true,
              isClosable: true,
              variant: "getNutrition",
              title: recipe.title,
            });
            return false;
          } else {
            // Cache the window scroll distance for the previous tab
            tabScrollY.current = {
              ...tabScrollY.current,
              [activeTabIndex]: y,
            };

            // Set the active tab index
            setActiveTabIndex(index);

            if (y < rect?.top) return;

            const defaultTop = rect?.top - topOffset + y;
            const top = tabScrollY.current[index];
            const targetTop = top > 0 && top > defaultTop ? top : defaultTop;

            window.scrollTo({
              top: targetTop,
            });
          }
        }}
        selectedIndex={activeTabIndex}
      >
        <div
          className={clsx(
            "left-0 right-0 top-34 z-30 border-b border-t bg-white px-6 py-6 transition ease-out lg:px-12",
            {
              "border-b-transparent": !sticky,
              "fixed border-b-zinc-200": sticky,
            }
          )}
        >
          <Tab.List
            className={clsx("tab-list-sm inline-flex w-full print:!hidden")}
          >
            <Tab className={clsx("tab flex-1 text-center")}>Ingredients</Tab>
            <Tab className={clsx("tab flex-1 text-center")}>Method</Tab>
            <Tab className={clsx("tab flex-1 text-center")}>Nutrition</Tab>
          </Tab.List>
        </div>
        <Tab.Panels
          className={clsx({
            "pt-21": sticky,
          })}
        >
          <Tab.Panel unmount={false}>
            <>
              <div className={clsx("px-6 py-4", {})}>{ingredients}</div>
              <div>{cta}</div>
            </>
          </Tab.Panel>
          <Tab.Panel unmount={false}>{method}</Tab.Panel>
          <Tab.Panel unmount={true}>
            <div className={clsx("px-6")}>
              <Nutrition recipe={recipe} />
            </div>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default RecipeTabs;
